var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { class: ["parametric-results", { "is-processing": _vm.isProc }] },
    [
      _c("h1", { staticClass: "parametric-results__title" }, [
        _vm._v(
          "\n        " +
            _vm._s(_vm.isEstateFlat ? "Квартиры" : "Коммерческая") +
            "\n        "
        ),
        _c("span", { staticClass: "parametric-results__label" }, [
          _vm._v(_vm._s(_vm.flats.length))
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          class: [
            "parametric-results__sort-panel",
            { "is-active": _vm.isShowPanel, "is-header": _vm.isScrollUp }
          ]
        },
        [
          _c("ul", { staticClass: "parametric-results__cards-sort" }, [
            _c(
              "li",
              [_c("Sort", { attrs: { name: "Этаж", type: "floor" } })],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [_c("Sort", { attrs: { name: "Сдача", type: "deadline" } })],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [_c("Sort", { attrs: { name: "Цена", type: "price" } })],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _vm.view === "desktop" && _vm.flats.length
        ? _c(
            "table",
            {
              class: [
                "parametric-results__table",
                _vm.isEstateFlat
                  ? "parametric-results__table_theme_flat"
                  : "parametric-results__table_theme_commerce"
              ]
            },
            [
              _c("thead", [
                _c("tr", [
                  _c("td", [_vm._v("Планировка")]),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "parametric-row__title-cell" },
                    [
                      _c("Sort", {
                        attrs: {
                          name: _vm.isEstateFlat ? "Квартира" : "Помещение",
                          type: "type"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "parametric-row__area-cell" },
                    [
                      _c("Sort", {
                        attrs: { name: "S, м<sup>2</sup>", type: "area" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isEstateFlat
                    ? _c(
                        "td",
                        [
                          _c("Sort", { attrs: { name: "Этаж", type: "floor" } })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c("Sort", { attrs: { name: "Cдача", type: "deadline" } })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "parametric-row__price-cell" },
                    [
                      _c("Sort", {
                        attrs: { name: "Цена, руб", type: "price" }
                      })
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.showFlats, function(flat) {
                  return _c("Row", {
                    key: flat.id,
                    attrs: { flat: flat, isEstateFlat: _vm.isEstateFlat }
                  })
                }),
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.view === "mobile" && _vm.flats.length
        ? _c(
            "div",
            { ref: "cards", staticClass: "parametric-results__cards" },
            [
              _c("ul", { staticClass: "parametric-results__cards-sort" }, [
                !_vm.isEstateFlat
                  ? _c(
                      "li",
                      [
                        _c("Sort", { attrs: { name: "Площадь", type: "area" } })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isEstateFlat
                  ? _c(
                      "li",
                      [_c("Sort", { attrs: { name: "Этаж", type: "floor" } })],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "li",
                  [_c("Sort", { attrs: { name: "Сдача", type: "deadline" } })],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  [_c("Sort", { attrs: { name: "Цена", type: "price" } })],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "parametric-results__cards-items" },
                _vm._l(_vm.showFlats, function(flat) {
                  return _c("Card", { key: flat.id, attrs: { flat: flat } })
                }),
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.counterHidden > 0
        ? _c(
            "div",
            { staticClass: "parametric-results__button-more" },
            [
              _c("More", {
                attrs: {
                  counterHidden: _vm.counterHidden,
                  counterFlats: this.flats.length
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.flats.length
        ? _c(
            "div",
            { staticClass: "parametric-results__no-result" },
            [
              _c("DustRunnerIcon"),
              _vm._v(" "),
              _c("h4", { staticClass: "parametric-results__no-result-title" }, [
                _vm._v("Вы совершили невозможное!")
              ]),
              _vm._v(" "),
              _c(
                "p",
                { staticClass: "parametric-results__no-result-description" },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.isEstateFlat ? "Квартир" : "Коммерческих помещений"
                      ) +
                      " не найдено. Пожалуйста, измените параметры\n            фильтра\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _c("ArrowIcon")
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }